// extracted by mini-css-extract-plugin
export default {"body":"HeaderAndFooter_body__tdWip","renderArea":"HeaderAndFooter_renderArea__dJNmL"};